import { Alert, Button, Col, Container, Form, Modal, Row, Tab, Tabs } from "react-bootstrap";
import DeckTopSection from "./Decks/DeckTopSection";
import { CustomTimeAgo, FeedbackButton, getDeckFormatsArray } from "../Commons/Functions";
import { useEffect, useRef, useState } from "react";
import { useGameContext } from "../Commons/GameContext";

export default function DeckBuilderTopSection(props) {
    const { currentGame } = useGameContext()
    const [showImportModal, setShowImportModal] = useState(false)
    const [importNotFound, setImportNotFound] = useState([])
    const [showExportModal, setShowExportModal] = useState(false)
    const [showEditModal, setShowEditModal] = useState(false)
    const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false)
    const [lastSavedDecklist, setLastSavedDecklist] = useState({})
    const [lastSavedName, setLastSavedName] = useState("")
    const [lastSavedFormat, setLastSavedFormat] = useState([])

    useEffect(() => {
        setLastSavedDecklist(props.deck.deckList)
        setLastSavedName(props.deck.title)
        setLastSavedFormat(getDeckFormatsArray(props.deck.format))
        const beforeUnload = async (e) => {
            if (props.hasUnsavedChangesRef.current) {
                e.preventDefault()
                return (e.returnValue = "Deck changes will be lost.")
            }
        }
        window.addEventListener('beforeunload', beforeUnload)
        return () => {
            window.removeEventListener("beforeunload", beforeUnload);
        };
    }, [])

    useEffect(() => {
        const tmpDeckFormats = getDeckFormatsArray(props.deck.format)
        if (props.deck.deckList !== lastSavedDecklist || props.deck.title != lastSavedName || !sameArrays(tmpDeckFormats, lastSavedFormat)) {
            setHasUnsavedChanges(true)
        } else {
            setHasUnsavedChanges(false)
        }
    }, [props.deck])

    useEffect(() => {
        props.hasUnsavedChangesRef.current = hasUnsavedChanges
    }, [hasUnsavedChanges])

    function save() {
        let deck = { ...props.deck }
        deck.lastModifiedAt = new Date()
        props.setDeck(deck)

        const deckData = JSON.parse(JSON.stringify(deck))
        deckData.deckList.categoriesOrder.forEach(cat => {
            deckData.deckList[cat].forEach((card, i) => {
                deckData.deckList[cat][i] = { count: card.count, id: card.id }
            })
        })

        const deckDataJSON = JSON.stringify(deckData);
        localStorage.setItem("user_decks_" + currentGame.selected + "_" + deck.id, deckDataJSON)
        setHasUnsavedChanges(false)
        setLastSavedDecklist(props.deck.deckList)
        setLastSavedName(props.deck.title)
        setLastSavedFormat(getDeckFormatsArray(props.deck.format))
    }

    function importList(input, shouldReplaceDeck) {
        const lignes = input.trim().split('\n');
        let sideboardIndexStart = 9999

        const tableau = lignes.map(ligne => {
            const [count, ...cardParts] = ligne.split(' ');
            const cardName = cardParts.join(' ').toLowerCase();
            if (count.toLowerCase().includes("sideboard")) {
                return { sideboardStart: true };
            }
            return { count: parseInt(count), cardName };
        });
        for (let i = 0; i < tableau.length; i++) {
            if (tableau[i].sideboardStart) {
                sideboardIndexStart = i
                tableau.splice(i, 1)
                i -= 1
            } else if (tableau[i].cardName.length <= 1) {
                tableau.splice(i, 1)
                i -= 1
            }
        }


        let cardsList = props.cardsListRef.current

        const comparableCardName = (str) => {
            return str.replace(/[^a-zA-Z0-9 ]/g, '')   // Remove everything except a-z, A-Z, 0-9, and spaces
                .replace(/\s+/g, ' ')                 // Replace multiple spaces with a single one
                .trim();
        }

        tableau.forEach((e) => {
            for (let i = 0; i < cardsList.length && !e.card; i++) {
                if (comparableCardName(cardsList[i].name.toLowerCase()) === comparableCardName(e.cardName)) {
                    e.card = { ...cardsList[i] }
                }
            }
            // If not found strict, search for part
            if (!e.card) {
                for (let i = 0; i < cardsList.length && !e.card; i++) {
                    if (comparableCardName(cardsList[i].name.toLowerCase()).includes(comparableCardName(e.cardName))) {
                        e.card = { ...cardsList[i] }
                    }
                }
            }
        })

        let notFound = []

        tableau.forEach((e) => {
            if (!e.card && e.cardName) {
                notFound.push(e.cardName)
            }
        })

        console.log(tableau, notFound)
        setImportNotFound(notFound)

        if (notFound.length == 0) {
            let tmp = { ...props.deck.deckList }
            if (shouldReplaceDeck) {
                tmp = { categoriesOrder: [], Sideboard: [] }
            }
            props.addCardsToDeckList(tableau, tmp, sideboardIndexStart)
            return true
        }
        return false
    }

    function applyDeckChanges(newName, newFormats) {
        let tmp = { ...props.deck }
        tmp.title = newName
        tmp.format = newFormats
        props.setDeck(tmp)
    }

    return (
        <DeckTopSection>
            <div className="d-flex mb-2">
                <Button onClick={() => setShowEditModal(true)}><img src={require('../Commons/Assets/Icons/edit.png')} /></Button>
                <h1 className="ms-3 mb-0 text-start">{props.deck.title}</h1>
            </div>
            <Row>
                <Col>
                    <div className="d-flex flex-row">
                        <p className="me-4">Created <CustomTimeAgo date={props.deck.createdAt} /></p>
                        <p>Last modified <CustomTimeAgo date={props.deck.lastModifiedAt} /></p>
                    </div>
                </Col>
                <Col className="d-flex flex-row justify-content-end">
                    {hasUnsavedChanges && (<FeedbackButton variant="secondary" onClick={() => save()} feedBack="Saved !">Save</FeedbackButton>)}
                    <Button variant="secondary" className="mx-1" onClick={() => setShowExportModal(true)}>Export</Button>
                    <Button className="" variant="secondary" onClick={() => setShowImportModal(true)}>Import</Button>
                </Col>
            </Row>
            <ImportModal show={showImportModal} handleClose={() => setShowImportModal(false)} importList={importList} notFound={importNotFound} />
            <ExportModal show={showExportModal} handleClose={() => setShowExportModal(false)} deckList={props.deck} />
            <EditModal
                show={showEditModal}
                handleClose={() => setShowEditModal(false)}
                deckName={props.deck.title}
                formats={props.gameData.deckBuilding.formats}
                deckFormats={props.deck.format}
                applyDeckChanges={applyDeckChanges}
            />
        </DeckTopSection>
    )
}

function ImportModal(props) {
    return (
        <Modal className="" show={props.show} onHide={props.handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>Import</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {props.notFound.map((cardName) => {
                    return (<Alert key={cardName} variant="danger">Card not found {cardName}</Alert>)
                })}
                <Form.Control id="import-decklist" as="textarea" placeholder="X Card name" rows={15} autoFocus />
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={() => {
                    props.handleClose()
                }}>
                    Cancel
                </Button>
                <Button variant="primary" onClick={() => {
                    let input = document.getElementById('import-decklist').value;
                    if (props.importList(input, false)) {
                        props.handleClose()
                    }
                }}>
                    Import and add
                </Button>
                <Button variant="primary" onClick={() => {
                    let input = document.getElementById('import-decklist').value;
                    if (props.importList(input, true)) {
                        props.handleClose()
                    }
                }}>
                    Import and replace
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

function ExportModal(props) {
    const [standardDeckList, setStandardDecklist] = useState("")
    const [tcgarenaDeckList, setTcgarenaDecklist] = useState("")

    function toStandardDeckList(deck) {
        let result = ""
        const decklist = deck.deckList
        if (decklist && decklist.categoriesOrder) {
            decklist.categoriesOrder.forEach((cat) => {
                if (decklist[cat]) {
                    decklist[cat].forEach((card) => {
                        result += card.count + " " + card.name + "\n"
                    })
                }
            })
        }
        return result
    }

    function toTcgarenaDeckList(deck) {
        if (!deck || !deck.deckList) { return "" }
        let result = JSON.parse(JSON.stringify(deck))
        const decklist = JSON.parse(JSON.stringify(deck.deckList))
        if (decklist && decklist.categoriesOrder) {
            decklist.categoriesOrder.forEach((cat) => {
                if (decklist[cat]) {
                    let newCat = []
                    decklist[cat].forEach((card) => {
                        newCat.push({ count: card.count, id: card.id })
                    })
                    decklist[cat] = newCat
                }
            })
        }
        result.deckList = decklist
        return JSON.stringify(result, null, 2);
    }

    return (
        <Modal className="" show={props.show} onHide={props.handleClose} centered
            onEnter={() => {
                setStandardDecklist(toStandardDeckList(props.deckList))
                setTcgarenaDecklist(toTcgarenaDeckList(props.deckList))
            }}
        >
            <Modal.Header closeButton>
                <Modal.Title>Export</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Tabs
                    defaultActiveKey="standard"
                    id="uncontrolled-tab-example"
                    className="box-container"
                    justify
                >
                    <Tab eventKey="standard" title="Standard"
                        onEntering={() => {
                        }}
                    >
                        <div className="box-container flex-column">
                            <p className="mb-3"></p>
                            <Form.Control id="import-decklist" as="textarea" value={standardDeckList} rows={20} readOnly autoFocus />
                            <FeedbackButton variant="secondary" onClick={() => {
                                navigator.clipboard.writeText(standardDeckList).then(function () {
                                }).catch(function (err) {
                                    console.error("Erreur lors de la copie : ", err);
                                });
                            }} feedBack="Copied !">
                                Copy
                            </FeedbackButton>
                        </div>
                    </Tab>
                    <Tab eventKey="tcg-arena" title="Starter deck"
                        onEntering={() => {
                        }}
                    >
                        <div className="box-container flex-column">
                            <p className="mb-3">ONLY USE THIS IF YOU ARE BUILDING STARTER DECKS FOR YOUR CUSTOM GAME. This is the internal decklists used by the app. Beside from building starter decks, there are no reasons for you to be using this.</p>
                            <Form.Control id="import-decklist" as="textarea" value={tcgarenaDeckList} rows={20} readOnly autoFocus />
                            <FeedbackButton variant="secondary" onClick={() => {
                                navigator.clipboard.writeText(tcgarenaDeckList).then(function () {
                                }).catch(function (err) {
                                    console.error("Erreur lors de la copie : ", err);
                                });
                            }} feedBack="Copied !">
                                Copy
                            </FeedbackButton>
                        </div>
                    </Tab>
                </Tabs>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={() => {
                    //props.createNewDeck()
                    props.handleClose()
                }}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

function EditModal(props) {
    const [newDeckFormats, setNewDeckFormats] = useState([])
    const [areFormatsCompatible, setAreFormatsCompatible] = useState(true)
    const [currentDeckCompatibility, setCurrentDeckCompatibility] = useState(undefined)

    // ONLY ALLOW COMPATIBLE FORMATS TO BE SELECTED

    function iniNewDeckFormats() {
        console.log("ini formats")
        const currentFormats = getDeckFormatsArray(props.deckFormats)
        if (currentFormats) {
            setNewDeckFormats(currentFormats)
        }
        if (currentFormats.length > 0) {
            props.formats.forEach((f) => {
                if (f.title === currentFormats[0]) {
                    setCurrentDeckCompatibility(f.compatibility)
                }
            })
        }
    }

    function checkForFormatsCompatibility(deckFormats) {
        let newCompatibility = undefined
        deckFormats.forEach((df) => {
            props.formats.forEach((gf) => {
                if (gf.title === df) {
                    if (newCompatibility === undefined) {
                        newCompatibility = gf.compatibility   
                        setCurrentDeckCompatibility(newCompatibility)
                    }
                    if (gf.compatibility !== newCompatibility) {
                        setAreFormatsCompatible(false)
                        return
                    }
                }
            })
        })
        setAreFormatsCompatible(true)
    }

    return (
        <Modal className="" show={props.show} onHide={props.handleClose} centered onEnter={iniNewDeckFormats}>
            <Modal.Header closeButton>
                <Modal.Title>Edit deck</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className='d-flex flex-row align-items-center justify-content-between'>
                    <p className="m-0">Name</p>
                    <div className="d-flex flex-row box-container w-75">
                        <Form.Control
                            type="text"
                            id="deck-title"
                            defaultValue={props.deckName}
                            placeholder="Deck name"
                        />
                    </div>
                </div>
                <div className='d-flex flex-row align-items-center justify-content-between'>
                    <p className="m-0">Formats</p>
                    <div className="d-flex flex-column box-container w-75">
                        {!areFormatsCompatible && (
                            <div className="box-container my-4" style={{ backgroundColor: "var(--main-color)" }}>
                                Your have selected incompatible formats.
                            </div>
                        )}
                        {props.formats.map((format, i) => (
                            <div key={format.title} className="mb-3">
                                <Form.Check
                                    type="checkbox"
                                    onChange={() => {
                                        const index = newDeckFormats.findIndex(a => a === format.title)
                                        let tmp = [...newDeckFormats]
                                        if (index !== -1) {
                                            tmp.splice(index, 1)
                                        } else {
                                            tmp.push(format.title)
                                        }
                                        setNewDeckFormats(tmp)
                                        checkForFormatsCompatibility(tmp)
                                    }}
                                    checked={newDeckFormats.includes(format.title)}
                                    id={`${format.title}-checkbox`}
                                    label={format.title}
                                />
                            </div>
                        ))}
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={() => {
                    props.handleClose()
                }}>
                    Cancel
                </Button>
                <Button
                    disabled={!(areFormatsCompatible && newDeckFormats.length > 0)}
                    variant="primary"
                    onClick={() => {
                        const newDeckName = document.getElementById('deck-title').value;
                        props.applyDeckChanges(newDeckName, newDeckFormats)
                        props.handleClose()
                    }}>
                    Apply changes
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

function sameArrays(a, b) {
    if (a.length !== b.length) return false;
  
    const sortedA = [...a].sort();
    const sortedB = [...b].sort();
  
    return sortedA.every((val, index) => val === sortedB[index]);
  }